export class AgentLicense {
  readonly state: string;
  readonly licenseNumber: string;
  readonly producerId: string;
  readonly startDate: Date;
  readonly endDate: Date;

  constructor(state: string, licenseNumber: string, producerId: string, startDate: Date, endDate: Date) {
    this.state = state;
    this.licenseNumber = licenseNumber;
    this.producerId = producerId;
    this.startDate = startDate;
    this.endDate = endDate;
  }

  toString() {
    return {
      state: this.state,
      licenseNumber: this.licenseNumber,
      producerId: this.producerId,
      startDate: this.startDate,
      endDate: this.endDate,
    };
  }
}
